import axios from "../http-client/axios";
import { SCORPIONS_URL } from "../urls/base-urls";


export async function getLink() {
  const resp = await axios.get(
    `${SCORPIONS_URL}/checkin`
  );
  return resp.data;
}
export default getLink;